import { CarPdfBoxProps } from "@app/components/PdfBox";
import { CarPdfChartLegend } from "@app/components/PdfChartLegend";
import { useTheme } from "@mui/material";

export const DftVersusTenYearReturnPdfChartLegend = (props: CarPdfBoxProps) => {
  const theme = useTheme();

  return (
    <CarPdfChartLegend
      {...props}
      items={[
        {
          label: "E(R) TREND LINE",
          color: theme.palette.chartsColor.green,
          isCircle: true,
        },
        {
          label: "UPPER & LOWER BOUNDS",
          color: theme.palette.softBlack,
          isCircle: true,
        },
        {
          label: "10-YEAR REAL RETURN",
          color: theme.palette.chartsColor.blue,
          isCircle: true,
        },
      ]}
    />
  );
};
